import { setFullbandMusicMonoAudioProfile } from '@studio/chime';
import { BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE } from 'actions/Types';

function setContentShareAudioProfile() {
  return (dispatch, getState) => {
    const {
      meeting: { meetingSession }
    } = getState();
    const action = {
      type: BROADCAST_UPDATE_CONTENT_SHARE_AUDIO_PROFILE,
      request: async () => {
        setFullbandMusicMonoAudioProfile(meetingSession);
        return true;
      }
    };

    dispatch(action);
  };
}

export default setContentShareAudioProfile;
